module.exports = __webpack_public_path__ + "img/logo.0186e69.svg?v=1751624816731";